import { combineReducers } from 'redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import throttle from 'lodash/throttle';
import rootReducer from './reducers/rootReducer';
import { loadState, saveState } from './localState';

const prepareStore = (preloadedState) => {
  const store = configureStore({
    reducer: combineReducers(rootReducer),
    middleware: [...getDefaultMiddleware()],
    preloadedState,
  });

  return store;
};

const preloadedState = loadState();
const store = prepareStore(preloadedState);

store.subscribe(
  throttle(() =>
    saveState({
      user: store.getState().user,
      theme: store.getState().theme,
    }),
  ),
);

export default store;
